import { Language } from './language';
import { Media } from './media';
import { DatabaseModel, ModelJson } from './database-model';
import { PageMeta } from './page-meta';
import { TourInfoSection } from './tour-info-section';
import { MoteType } from './mote.data';
import { Voucher } from './voucher';

export class TourInfo extends DatabaseModel implements PageMeta {
    // Unique key / id of the tour info
    public key: string = '';
    // Tour key
    public tourKey: string = '';
    // Title of the tour info page
    public title: string = '';
    // Media element for cms-editor
    public media: Media = null;
    // Language of info page
    public language: Language;
    // Map of product keys associated with the tour info
    public products: { [productKey: string]: boolean } = {};
    // Text describing the tour for google (implements PageMeta)
    public description: string = "";
    // Meta description for google (implements PageMeta)
    public keywords: string = "";
    // Tour length description
    public duration: number = 0;
    // Tour type
    public type: MoteType;
    // Start place
    public startPlace: string = "";
    // Tour length
    public length: number = 0;
    // Free tour text
    public freeTourText: string = "";
    // Tour price
    public price: number = 0;
    // Tour price label
    public priceLabel: string = '';
    // Number of stories
    public storyCountLabel: string = '';
    // User's tour voucher if any
    public userVoucher: Voucher = null;
    // OBS: Static set to true
    public readonly published: boolean = true;
    /** 
     * Sections array (mark as map when transformed to firebase schema) 
     * @asType object 
     * @additionalProperties { "$ref": "#/definitions/TourInfoSection" } 
     */
    public sections: TourInfoSection[] = [];

    /**
     * Construct a tour info object and call DatabaseModel super constructor
     */
    constructor(key: string = '', json: any = null) {
        super();
        if(key) this.key = key;
        if(json) this.fromJson(json);
    }

    /**
     * Create model instance from json text (deserialize)
     */
    public fromJson(json: ModelJson): TourInfo {
        Object.assign(this, json);
        // Map media and section json to instances
        this.media = json.media ? new Media(json.media) : null;
        this.sections = this.fromJsonMapToArray<TourInfoSection>(json.sections, TourInfoSection);

        return this;
    }

    /**
     * Serialize model to json text
     */
    public toJson(): ModelJson {
        let json = Object.assign({}, this);
        // Map special objects to json
        (json.media as ModelJson) = this.media ? this.media.toJson() : null;
        (json.sections as ModelJson) = this.toJsonMapFromArray(this.sections);

        return json;
    }
}
